module.exports = __webpack_public_path__ + "static/media/12UNCTAD17.b3a83fa3.jpg";